@import '../../global/style/all-tenants/custom-properties/components-properties/splide-sliders';
@import '../../global/style/all-tenants/custom-properties/components-properties/dynamic-teaser';

:host {
  @include cms-components-host-defaults;
}

cms-headline[headline-tag="h2"] {
  --cms-spacing-bottom: var(--cms-spacing-100);
}

.teaser-rondel-inner {
  @include cms-default-grid-container;
}

.splide {
  @include splide-root;
}

.splide__sr {
  @include splide-sr;
}

.splide__track--draggable {
  @include splide-track-draggable;
}

.splide__list {
  --cms-grid-gap: 0;
  @include splide-list;
  grid-auto-columns: calc(100% / var(--cms-view-slides));
}

.splide__slide {
  @include splide-slide;
  background-color: var(--cms-semanticColors-base-medium-background);
  margin-right: var(--cms-spacing-075);
}

.splide__track {
  @include splide-track;
}

.splide-arrow {
  @include splide-arrow;
}

.splide__arrow--prev {
  @include splide-arrow-prev;
}

.splide__arrow--next {
  @include splide-arrow-next;
}

.teaser-rondel-text {
  padding: 0 var(--cms-spacing-100) var(--cms-spacing-100) var(--cms-spacing-100);
  margin-bottom: var(--cms-spacing-075);
  margin-top: 0;
}

.content-wrapper-inner {
  padding-top: var(--cms-spacing-100);
}

.content-wrapper,
.splide__slide__container {
  height: 100%;
}

.teaser-rondel-link {
  color: var(--cms-semanticColors-base-medium-textOnBackground);
  text-decoration: none;
  display: flex;
  flex-direction: column;
}

.content-wrapper-inner cms-headline {
  --cms-grid-padding: 0 var(--cms-spacing-100);
}

cms-headline {
  --cms-grid-padding: 0;
}

.bg-color {
  background-color: var(--cms-semanticColors-base-medium-background);
}

.scratch svg path {
  fill: var(--cms-semanticColors-base-medium-background);
}

.badge-wrapper {
  @include dynamic-teaser-badge
}

.splide-mobile-pagination {
  @include splide-mobile-pagination;
}

@include media-width($breakpoint-sm) {
  cms-headline[headline-tag="h2"] {
    --cms-spacing-bottom: var(--cms-spacing-150);
  }
}